export const COMPONENT_DID_CATCH = 'ERRORS/COMPONENT_DID_CATCH'

export const componentDidCatch = error => ({
  payload: error,
  type: COMPONENT_DID_CATCH,
})
